import type { ChequeDaPessoa, Programa } from '../../premiacao';

/**
 * As contas de um vendedor na semana (itens por situação), as MESMAS da tela da Conferência e das
 * folhas A4: se cada lugar contasse do seu jeito, a folha impressa não bateria com a tela.
 */
export type Conta = {
  lancado: number;
  confirmado: number;
  aguardando: number;
  naoVendeu: number;
  naoLancou: number;
  diaErrado: number;
  loteDoDia: number;
  abaixo: number;
  canceladas: number;
  devolvidas: number;
  perdeuReais: number;
};

export const PROGRAMAS: readonly { id: Programa; nome: string; curto: string }[] = [
  { id: 'vitamina', nome: 'Vitamina', curto: 'Vit.' },
  { id: 'pre_vencido', nome: 'Pré-vencido', curto: 'Pré-v.' },
  { id: 'paradao', nome: 'Paradão', curto: 'Parad.' },
];
export const NOME_DO_PROGRAMA: Record<Programa, string> = {
  vitamina: 'Vitamina',
  pre_vencido: 'Pré-vencido',
  paradao: 'Paradão',
};
export const somaQtd = (xs: readonly { qtd: number }[]) => xs.reduce((s, x) => s + x.qtd, 0);

export function contas(c: ChequeDaPessoa, semRelatorio: ReadonlySet<string>): Conta {
  const L = c.linhas;
  const loteDoMesmoDia = L.loteDoMesmoDia ?? [];
  const aguardando = somaQtd(L.naoVendeu.filter((l) => semRelatorio.has(l.dia)));
  const naoVendeu = somaQtd(L.naoVendeu.filter((l) => !semRelatorio.has(l.dia)));
  const diaErrado = somaQtd(L.diaErrado);
  const loteDoDia = somaQtd(loteDoMesmoDia);
  const abaixo = somaQtd(L.abaixoDoCard);
  const confirmado = somaQtd(L.bate);
  return {
    lancado: confirmado + abaixo + aguardando + naoVendeu + diaErrado + loteDoDia,
    confirmado,
    aguardando,
    naoVendeu,
    naoLancou: somaQtd(L.naoLancou),
    diaErrado,
    loteDoDia,
    abaixo,
    canceladas: somaQtd(L.canceladas),
    devolvidas: somaQtd(L.devolvidos),
    perdeuReais: c.perdeu,
  };
}
